/* ============================================================
   Shopailo — theme.js  (vanilla, no dependencies)
   ============================================================ */
(function () {
  "use strict";

  var money = function (cents) {
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return "$" + (cents / 100).toFixed(2);
  };

  /* ---------- Accordion ---------- */
  function initAccordions() {
    document.querySelectorAll(".accordion__trigger").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", function () {
        var expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!expanded));
        var panel = document.getElementById(btn.getAttribute("aria-controls"));
        if (!panel) return;
        panel.hidden = false;
        if (expanded) {
          panel.style.maxHeight = "0px";
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  /* ---------- Announcement rotation ---------- */
  function initAnnouncement() {
    document.querySelectorAll("[data-announcement]").forEach(function (bar) {
      var msgs = bar.querySelectorAll(".announcement__msg");
      if (msgs.length < 2) return;
      var i = 0;
      var speed = parseInt(bar.dataset.speed, 10) || 4000;
      setInterval(function () {
        msgs[i].classList.remove("is-active");
        i = (i + 1) % msgs.length;
        msgs[i].classList.add("is-active");
      }, speed);
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var menu = document.getElementById("MobileMenu");
    if (!menu) return;
    var open = document.querySelector("[data-open-menu]");
    function close() { menu.classList.remove("is-open"); document.body.style.overflow = ""; }
    if (open) open.addEventListener("click", function () { menu.classList.add("is-open"); document.body.style.overflow = "hidden"; });
    menu.querySelectorAll("[data-close-menu]").forEach(function (el) { el.addEventListener("click", close); });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var slidesWrap = gallery.querySelector(".gallery__slides");
      var thumbs = gallery.querySelectorAll(".gallery__thumb");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var idx = parseInt(thumb.dataset.index, 10);
          var slide = slidesWrap.children[idx];
          if (slide) slidesWrap.scrollTo({ left: slide.offsetLeft - slidesWrap.offsetLeft, behavior: "smooth" });
        });
      });
      if (slidesWrap) {
        slidesWrap.addEventListener("scroll", function () {
          var idx = Math.round(slidesWrap.scrollLeft / slidesWrap.clientWidth);
          thumbs.forEach(function (t, i) { t.classList.toggle("is-active", i === idx); });
        }, { passive: true });
      }
    });
  }

  /* ---------- Quantity selector ---------- */
  function initQty() {
    document.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      wrap.querySelectorAll("[data-qty-btn]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var val = parseInt(input.value, 10) || 1;
          val += btn.dataset.qtyBtn === "up" ? 1 : -1;
          if (val < 1) val = 1;
          input.value = val;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product form: variants + add to cart ---------- */
  function initProductForm() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var dataEl = document.getElementById(form.dataset.variantsId);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent || "[]");
      var idInput = form.querySelector("[name='id']");
      var selected = {};

      // initialise from pre-selected swatches
      form.querySelectorAll(".variant-swatch.is-selected").forEach(function (s) {
        selected[s.dataset.optionIndex] = s.dataset.value;
      });

      function currentVariant() {
        return variants.find(function (v) {
          return (!selected["1"] || v.option1 === selected["1"]) &&
                 (!selected["2"] || v.option2 === selected["2"]) &&
                 (!selected["3"] || v.option3 === selected["3"]);
        });
      }

      function updateUI() {
        var v = currentVariant();
        var atc = form.querySelector("[data-atc]");
        if (!v) {
          if (atc) { atc.disabled = true; atc.querySelector("[data-atc-text]").textContent = "Unavailable"; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (atc) {
          atc.disabled = !v.available;
          atc.querySelector("[data-atc-text]").textContent = v.available ? (atc.dataset.addText || "Add to cart") : "Sold out";
        }
        document.querySelectorAll("[data-variant-price]").forEach(function (el) { el.innerHTML = money(v.price); });
        document.querySelectorAll("[data-variant-compare]").forEach(function (el) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            el.innerHTML = money(v.compare_at_price); el.style.display = "";
          } else { el.style.display = "none"; }
        });
      }

      form.querySelectorAll(".variant-swatch").forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          var idx = swatch.dataset.optionIndex;
          selected[idx] = swatch.dataset.value;
          form.querySelectorAll(".variant-swatch[data-option-index='" + idx + "']").forEach(function (s) {
            s.classList.toggle("is-selected", s === swatch);
          });
          updateUI();
        });
      });

      form.addEventListener("submit", function (e) {
        if (!window.Shopify) return; // let it post normally if JS cart unavailable
        e.preventDefault();
        var btn = form.querySelector("[data-atc]");
        if (btn) btn.disabled = true;
        var fd = new FormData(form);
        fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function () { return CartAPI.refresh(); })
          .then(function () { CartAPI.open(); })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.disabled = false; });
      });

      updateUI();
    });
  }

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  function initStickyAtc() {
    var sticky = document.querySelector("[data-sticky-atc]");
    var anchor = document.querySelector("[data-atc-anchor]");
    if (!sticky || !anchor) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle("is-visible", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    obs.observe(anchor);
    var stickyBtn = sticky.querySelector("[data-sticky-add]");
    if (stickyBtn) {
      stickyBtn.addEventListener("click", function () {
        var mainAtc = document.querySelector("[data-atc]");
        if (mainAtc && !mainAtc.disabled) mainAtc.click();
      });
    }
  }

  /* ---------- Cart drawer API ---------- */
  var CartAPI = {
    drawer: null,
    open: function () {
      this.drawer = this.drawer || document.getElementById("CartDrawer");
      if (this.drawer) { this.drawer.classList.add("is-open"); document.body.style.overflow = "hidden"; }
    },
    close: function () {
      if (this.drawer) { this.drawer.classList.remove("is-open"); document.body.style.overflow = ""; }
    },
    refresh: function () {
      return fetch("/?section_id=cart-drawer")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var fresh = tmp.querySelector("#CartDrawer");
          var current = document.getElementById("CartDrawer");
          if (fresh && current) current.replaceWith(fresh);
          CartAPI.drawer = document.getElementById("CartDrawer");
          bindCartDrawer();
          updateCartCount();
        });
    }
  };
  window.CartAPI = CartAPI;

  function updateCartCount() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "" : "none";
        });
      }).catch(function () {});
  }

  function bindCartDrawer() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return;
    drawer.querySelectorAll("[data-close-cart]").forEach(function (el) {
      el.addEventListener("click", function () { CartAPI.close(); });
    });
    drawer.querySelectorAll("[data-cart-change]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = btn.dataset.line;
        var qty = parseInt(btn.dataset.qty, 10);
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
        }).then(function () { return CartAPI.refresh(); });
      });
    });
    drawer.querySelectorAll("[data-cart-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: btn.dataset.cartAdd, quantity: 1 })
        }).then(function () { return CartAPI.refresh(); });
      });
    });
  }

  function initCartTriggers() {
    document.querySelectorAll("[data-open-cart]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        if (document.getElementById("CartDrawer")) { e.preventDefault(); CartAPI.open(); }
      });
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initAccordions();
    initAnnouncement();
    initMobileMenu();
    initGallery();
    initQty();
    initProductForm();
    initStickyAtc();
    initCartTriggers();
    bindCartDrawer();
    updateCartCount();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init sections in the theme editor
  document.addEventListener("shopify:section:load", init);
})();
